import { Router, Params, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, OnInit} from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { LoginService } from './login.service';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';


//  Jquery imports
// import * as jquery from 'jquery';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  public load: boolean;
  public modules: any;
  public urls: any;
  public loginForm: FormGroup;
  public activeform: any;
  private user: any;

  constructor(
    private _loginService: LoginService,
    public _router: Router,
    private _sharedService: SharedService,
    public activatedRoute: ActivatedRoute,
    public toastr: ToastsManager,
    private logger: Logger,
    private fb: FormBuilder,
  ) {
    this.load = false;
    this.activeform = {login: true, recoverpass: false};
    this.loginForm = this.fb.group({
        email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
        password: ['', [Validators.required, Validators.minLength(6)]]
      });

  }

  ngOnInit () {
  }

  onLogin() {

    this.load = true; // loading screen


    this._loginService.login(this.loginForm.value).subscribe(
      data => {
        console.log(data.status);

        if (data.status) {
          this._sharedService.setCookie('auth_token', data.data[0].token, null, environment.c_domain );
          this._sharedService.initUser();
          this.toastr.success('Has iniciado sesión correctamente!', 'Éxito!');
          let bot = document.getElementById('live-chat');
          bot.style.display='block';
          this._router.navigate(['/dashboard', {}]);
      } else {
          this.toastr.error('Sus credenciales son incorrectas, por favor intente de nuevo', 'Error');
          this.logger.log(data.message);
      }

        this.load = false;
      },
      error => {
        this.logger.log(error);
        this.toastr.error('Ocurrió un error, por favor intente de nuevo', 'Error');
        this.load = false;

      }
    ), error => {
      console.log('Ups, ocurrió un error: ', error);
    };

  }

  callRecoverForm() {
    this.activeform.login = false;
  }

  callLoginForm() {
    this.activeform.login = true;
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/auth/login/login.component.ts